import { gql } from '@apollo/client'

export const CORE_CONFIG_FIELDS = gql`
	fragment CoreConfigFields on Config {
		rallyCode
		rallyName
		rallyType
		days
		legs
		isLegsOV
		isMultipleLegsPerDay
		isMultiRaces
		isAuthentic
		isRiders
		ridersName
		isPrologue
		isPrologueDay1
		isPrologueDisplayOV
		isCH
		isCHS
		isJokersCHS
		isSC
		isCP
		mixDisplayRaces
		isSplitCHS
		isDecimal
		nbDecimals
		isTimeTotal
		isDisplayRetirements
		isDisplayAVG
		isGroup
		isDisplayGroup
		isDisplayGroupPos
		isClass
		isDisplayClass
		isDisplayClassPos
		isDisplayCoef
		isDisplayCapacity
		isDisplayCapacityStartingList
		isDisplayCarRT
		isDisplayCarOV
		isDisplayTeam
		isDisplayFlags
		flagsServer
		rtPrefix
		nameCH
		nameCHS
		nameSC
		nameDay
		nameCar
		isRallyNameHeader
		primaryColor
		secondaryColor
		pollInterval
		isPartialOV
		timeZone
		isRoadbook
		isDepartureSplit
		roadbookInterval
		isDeparturePM
		isDisplayOV
		isDisplayRT
		isDisplayPDF
		isDisplayDepartures
		isDisplayRTName
	}
`
